<div class="confirmation-dialog">
  <div class="dialog-title-bar">
    <h2 class="dialog-title" data-testid="cancel-scope-dialog-title">Cancel Job/Files</h2>
    <button type="button" class="close-btn" aria-label="Close dialog" (click)="onClose()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
          fill="white"
        />
      </svg>
    </button>
  </div>

  <div class="warning-banner" data-testid="cancel-warning-message">
    <img
      class="warning-banner__icon"
      src="assets/icons/cancel-warning.svg"
      alt=""
      aria-hidden="true"
    />
    <p class="warning-banner__text">
      If you cancel at this stage,
      <span class="warning-banner__emphasis">charges may apply</span>
      for any completed translation work.
    </p>
  </div>

  <mat-dialog-content class="dialog-body" data-testid="cancel-scope-dialog">
    <p class="cancel-job-scope__subtitle">Please select what you would like to cancel:</p>

    <mat-radio-group
      class="cancel-job-scope__options"
      [value]="selectedScope()"
      (change)="onScopeChange($event.value)"
      aria-label="Cancellation scope"
    >
      <mat-radio-button value="ENTIRE_JOB" data-testid="cancel-scope-entire-job">
        Entire translation job
      </mat-radio-button>
      <mat-radio-button value="SPECIFIC_FILES" data-testid="cancel-scope-specific-files">
        Specific files
      </mat-radio-button>
    </mat-radio-group>

  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      type="button"
      class="btn btn-outline"
      data-testid="cancel-scope-close"
      (click)="onClose()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      data-testid="cancel-scope-continue"
      (click)="onContinue()"
    >
      Confirm
    </button>
  </mat-dialog-actions>
</div>
